import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { iniciarIdioma } from './i18n/idioma';
import { travarZoomNavegador } from './input/travarZoom';
import { instalarCursor } from './input/cursor';
import { ehWiki } from './screens/wiki/rota';
import { SessionProvider } from './state/SessionContext';
import { instalarColeta } from './suporte/coleta';
import { instalarAtualizacao } from './sistema/atualizacao';
import { instalarDicas } from './ui/dica';

import './styles/tokens.css';
import './styles/base.css';
import './styles/gump.css';
import './styles/kit.css';
import './styles/screens.css';
import './styles/criacao.css';
import './styles/hud.css';
import './styles/mercado.css';
import './styles/hud-topo.css';
import './styles/cursor.css';
import './styles/suporte.css';
import './styles/rankings.css';
import './styles/vender.css';
import './styles/compra.css';
import './styles/v3-janelas.css';
import './styles/v3-cacadas.css';
import './styles/v3-coleta.css';
import './styles/v3-resgate.css';
import './styles/v3-menu-jogador.css';
import './styles/v3-perfil.css';
import './styles/v3-topo.css';
import './styles/v3-barra.css';
import './styles/v3-leilao.css';
import './styles/v3-chat.css';
import './styles/v3-loja.css';
import './styles/v3-oficina.css';
import './styles/v3-casa.css';
import './styles/v3-guardaroupa.css';
import './styles/v3-eventos.css';
import './styles/v3-correio.css';
import './styles/v3-indica.css';
import './styles/gm.css';
import './styles/dica.css';

// A Wiki é página de leitura: o zoom do navegador fica livre lá (acessibilidade).
if (!ehWiki(window.location.pathname)) travarZoomNavegador();
instalarCursor();
instalarColeta();
instalarAtualizacao();
// As dicas do jogo no lugar do title do navegador (techspec-dicas).
instalarDicas();

const host = document.getElementById('root');
if (!host) throw new Error('Elemento #root não encontrado em index.html.');

// O catálogo é esperado antes do primeiro render: assim nunca existe um quadro
// com chave crua na tela. Sem `await` de topo — o alvo do build não aceita.
void iniciarIdioma().then(() => {
  createRoot(host).render(
    <StrictMode>
      <SessionProvider>
        <App />
      </SessionProvider>
    </StrictMode>
  );
});
